import api from '@/services/api/api';

export const useHistorianLibrary = () => {
  const historianLibrary = useQuery(
    ['historianLibrary'],
    async () => {
      const { data } = await api.articles.getHistorianLibrary();
      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await historianLibrary.suspense();
  });

  return {
    historianLibrary,
  };
};
